<template>
  <div>
    <el-row class="sign-up-form">
      <el-col :span="22">
        <div class="sign-up-form-input">
          <el-form :label-position="lablePosition" label-width="13rem" ref="ruleForm" :model="form">
            <el-form-item label="作品名称：" prop="worksName">
              <el-input placeholder="请输入项目名称" v-model="form.workName" readonly></el-input>
            </el-form-item>
            <el-form-item label="作品简介：" prop="brief">
              <el-input
                v-model="form.brief"
                type="textarea"
                :autosize="{minRows: 4, maxRows: 4}"
                readonly
              ></el-input>
            </el-form-item>
              <el-form-item label="作品附件:" prop="logo">
                <!--                <fileComponentList-->
                <!--                  :businessCodeArray="businessCodeArray"-->
                <!--                  :remark="remark"-->
                <!--                  :completeArray="completeArray"-->
                <!--                ></fileComponentList>-->
                <div class="fileupload">
                  <el-row :gutter="10">
                    <el-col :span="20">
                      <el-card class="box-card" style="margin-top: 10px">
                        <div slot="header" class="clearfix">
                          <i class="el-icon-folder-checked"></i>
                          <span>作品相关文件</span>
                        </div>

                        <div
                          class="text item"
                          v-for="(item, index) in fileList"
                          :key="index"
                        >
                          <el-row>
                            <el-col :span="16">
                              <i class="el-icon-folder-checked"></i>
                              <span>{{item.fileDict}} : <a :href="item.path">{{ item.name }}</a></span>
                            </el-col>
                          </el-row>
                        </div>
                      </el-card>
                    </el-col>
                  </el-row>
                </div>
              </el-form-item>
          </el-form>
        </div>
      </el-col>
    </el-row>
    <el-row class="sign-up-form">
      <!-- 列表 -->
      <el-table ref="multipleTable" :data="tableData" style="width: 100%">
        <el-table-column prop="expertName" label="专家" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="grade" label="成绩" align="center"></el-table-column>
        <el-table-column prop="comment" label="评语" align="center"></el-table-column>
<!--        <el-table-column label="操作" align="center" class-name="small-padding fixed-width">-->
<!--          <template slot-scope="scope">-->
<!--            <el-button-->
<!--              size="mini"-->
<!--              type="text"-->
<!--              icon="el-icon-delete"-->
<!--              @click="handleRevert(scope.row)"-->
<!--            >驳回</el-button>-->
<!--          </template>-->
<!--        </el-table-column>-->
      </el-table>
    </el-row>
  </div>
</template>

<script>
import ChildLogo from '@/components/ChildLogo.vue'
import commitment from '@/components/commitment'
import loginForm from '@/components/login'
import fileCompomemt from '@/components/fileComponent'
import fileComponentList from '@/components/fileComponentList'
import { getTitles, getSite } from '@/api/work/index'
import { deleteFiles, getFileList } from '@/api/system/index'
import {getWorkFile} from '@/api/work/workdata'

export default {
  components: {
    ChildLogo,
    commitment,
    loginForm,
    fileCompomemt,
    fileComponentList
  },
  data () {
    return {
      // 作品id
      workId: undefined,
      // 专家id
      expertId: undefined,
      // 类型
      worksTypes: [],
      fileList: [],
      fileIdList: [],
      businessCodeArray: [],
      completeArray: [],
      tableData: [],
      form: {
        id: null,
        ids: [],
        worksName: '',
        worksType: '',
        worksLeader: '',
        userName: '',
        duty: '',
        mobile: '',
        cooperator: '',
        responsibility: '',
        participantId: null,
        siteId: this.siteId,
        final_grade: '',
        remark: '',
        comment: ''
      },
      markType: undefined,
      remark: undefined,
      lablePosition: 'right'
    }
  },
  created () {
    this.workId = this.$route.query.id
    this.expertId = this.$route.query.expertId
    // 作品分类
    getSite(this.siteURL, this.siteId).then((response) => {
      getTitles(this.siteURL, response.data.remark).then((res) => {
        this.worksTypes = res.data
        this.getFileSList(this.workId)
      })
    })
  },
  beforeMount () {
    // 添加判断方法
    let mobile = navigator.userAgent.match(
      /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    )
    if (mobile) {
      this.lablePosition = 'top'
    }
  },
  mounted () {
    this.getSiteInfo()
    /* 查询评分方式 */
    var urlRule = this.siteURL + '/actuator/rule/getInfoBYSiteId'
    this.axios
      .get(urlRule, { params: { siteId: this.siteId } })
      .then((response) => {
        if (response.data.code === 200) {
          this.markType = response.data.data.ruleId
        }
      })
  },
  methods: {
    getSiteInfo () {
      var url = this.baseURL + '/actuator/works/getInfoDetail'
      this.axios.get(url, { params: { id: this.workId, expertNumber: this.expertId } }).then((response) => {
        if (response.data.code === 200) {
          console.log(response.data.data[0])
          let works = JSON.parse(response.data.data[0].worksName)

          this.form = works
          this.remark = this.form.remark
          this.tableData = response.data.data
          this.tableData.forEach(item => {
            if (item.status == 0) {
              item.comment = undefined
              item.grade = undefined
            }
          })
        }
      })
    },
    getContParticipant () {},
    /**
     * 获取作品列表
     */
    getFileSList (id) {
      getWorkFile(this.siteURL, id).then((response) => {
        let files = []
        response.data.forEach(function (item, index) {
          let file = {}
          file.fileDict = item.fileDict
          file.name = item.fileName
          file.path = item.path
          files.push(file)
        })
        this.fileList = files
      })
      // if(this.remark === "") {
      //   return
      // }
      // if (this.businessCodeArray) {
      //   getFileList(url, this.remark).then((res) => {
      //         this.completeArray = res.data.completeArray
      //        for (let i = 0; i < res.data.completeArray.length; i++) {
      //         this.fileList.push({
      //           name: res.data.completeArray[i].fileName,
      //           url: res.data.completeArray[i].path,
      //         });
      //       }
      //   });
      // }
    }
    // // /** 驳回操作 */
    // handleRevert(row) {
    //   this.$confirm(
    //     "此操作会使此专家这个作评评分清空，需重新评审作品, 是否继续?",
    //     "提示",
    //     {
    //       confirmButtonText: "确定",
    //       cancelButtonText: "取消",
    //       type: "warning",
    //     }
    //   )
    //     .then(() => {
    //       var url = this.siteURL + "/actuator/workExport/rejected/"+row.id+"/"+row.expertId;
    //       this.axios.get(url).then((response) => {
    //         if (response.data.code === 200) {
    //           this.updateFinalyGrade(row.id)
    //           this.getSiteInfo();
    //         }
    //       });
    //     })
    //     .catch(() => {
    //       this.$message({
    //         type: "info",
    //         message: "已取消驳回",
    //       });
    //     });
    // },
    /** 求专家平均值  修改作品最终值   这里有问题 感觉会导致一致性  数据库性能问题 */
    // updateFinalyGrade(id) {
    //   //回去根据评分方法求得的最终成绩
    //   var workExport = { contWorkExportList: [{workId:undefined}] };
    //   var url = this.siteURL + "/actuator/workExport/getAvgGrade";
    //   workExport.markType = this.markType;
    //   workExport.contWorkExportList[0].workId = id;
    //   this.axios.post(url, workExport).then((response) => {
    //     if (response.data.code === 200) {
    //       var data = { contWorksList: [] };
    //       var workUrl = this.baseURL + "/actuator/works/updateGrade";
    //       //循环生成对象
    //       response.data.data.forEach((element) => {
    //         data.contWorksList.push({
    //           id: element.workId,
    //           finalGrade: element.grade,
    //         });
    //       });
    //       this.axios.post(workUrl, data).then((response) => {
    //         if (response.data.code === 200) {
    //           console.log(response);
    //         }
    //       });
    //     }
    //   });
    // },
  }
}
</script>

<style scoped>
/* 通知公告基础模块 */
.sign-up {
  min-height: 80px;
}

/* 通知公告竖线样式 */
.sign-up-line {
  float: left;
  width: 5px;
  height: 50px;
  background-image: linear-gradient(#133c73, #37babd);
  margin-top: 20px;
}

.sign-up-text {
  margin-left: 10px;
  float: left;
  height: 40px;
  margin-top: 20px;
}

.sign-up-text-cn {
  font-size: 24px;
}

.sign-up-text-en {
  font-size: 15px;
  color: #666666;
}

/* 表单基础样式 */
.sign-up-form {
  margin-top: 10px;
  height: 100%;
  padding: 5rem 5rem;
  background-color: #f5f5f5;
}

.sign-up-form-input {
  width: 100%;
  background-color: #f5f5f5;
}

/* elementui   表单控件长度修改 */
.el-select {
  width: 100%;
}

.el-input {
  width: 100%;
}

.bottom {
  margin-top: 0;
  text-align: center;
  color: #409eff;
  line-height: 19px;
  font-size: 14px;
  cursor: pointer;
}

.buttonDiv {
  margin: 50px;
  padding: 0 25%;
}

.el-upload__tip {
  line-height: 20px;
}
</style>
<style>
.el-form-item__label {
  font-size: 16px !important;
}

.el-upload-list__item-name {
  cursor: pointer;
}

.el-upload-list__item-name:hover {
  color: #409eff;
}

.el-radio__input.is-checked + .el-radio__label {
  color: #39c1c2;
}

.el-radio__input.is-checked .el-radio__inner {
  border-color: #39c1c2;
  background: #39c1c2;
}
</style>



// WEBPACK FOOTER //
// src/views/WorkDetailAll.vue